export default class AppEnviroment {
    private static gatewayUrl = process.env.REACT_APP_HST_GATEWAY_URL || " http://localhost:8080/api"
    private static sharedUrl = process.env.REACT_APP_HST_URL_FOR_ACCOMODATION_QRCODE || `https://hostyble.netlify.app/open-app?qrCodeId=`;

    public static getGatewayUrl(){
        return this.gatewayUrl;
    }
    public static getSharedUrl(){
        return this.sharedUrl;
    }
}
